import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';

export default function ManageLeasing() {

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [viewData, setViewData] = useState(null);

  const [page, setPage] = useState(1);
  const limit = 10;
  const [total, setTotal] = useState(0);

  const fetchData = () => {
    API.get(`/leasing?page=${page}&limit=${limit}`)
      .then(res => {
        setData(res.data.data);
        setTotal(res.data.total);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // ✅ SELECT ALL
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(data.map(x => x.leasinginq_id));
    } else {
      setSelected([]);
    }
  };

  // ✅ SELECT ONE
  const handleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  // ✅ DELETE MULTIPLE
  const handleDeleteMultiple = async () => {
    if (selected.length === 0) {
      alert("Select at least one");
      return;
    }

    await API.post('/leasing/delete', { ids: selected });
    setSelected([]);
    fetchData();
  };

  // ✅ DELETE SINGLE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await API.delete(`/leasing/${id}`);
    fetchData();
  };

  // ✅ VIEW
  const handleView = async (id) => {
    const res = await API.get(`/leasing/${id}`);
    setViewData(res.data);
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <Layout activePage="Leasing Inquiry">
       <div style={S.header}>
        <h2 style={S.title}>Manage Leasing Inquiry</h2>
        <p style={S.subtitle}>View and Manage Leasing Inquiry</p>
      </div>

      <div style={{ ...S.card,  gap: 12, padding: '16px 20px', backgroundColor: '#fff', marginBottom: 30 }}>
      <button style={{... S.delBtn,float:'right',marginBottom:'10px'}} onClick={handleDeleteMultiple}>
        Delete Selected
      </button>

      <table style={S.table}>
        <thead>
          <tr>
            <th>
              <input style={S.input} type="checkbox" onChange={handleSelectAll} />
            </th>
            <th style={S.th}>#</th>
            <th style={S.th}>Name</th>
            <th style={S.th}>Email</th>
            <th style={S.th}>Mobile</th>
            <th style={S.th}>Date</th>
            <th style={S.th}>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => (
            <tr key={row.leasinginq_id}>
              <td style={S.td}>
                <input style={S.input}
                  type="checkbox"
                  checked={selected.includes(row.leasinginq_id)}
                  onChange={()=>handleSelect(row.leasinginq_id)}
                />
              </td>

              <td style={S.td}><span style={S.serial}>{(page-1)*limit + i + 1}</span></td>
              <td style={S.td}><span style={S.nameChip}>{row.name}</span></td>
              <td style={S.td}><span style={S.groupChip}>{row.email}</span></td>
              <td style={S.td}><span style={S.serial}>{row.contact_no}</span></td>
              <td style={S.td}>{row.inq_create_date}</td>

              <td>
                <button style={S.viewBtn} onClick={()=>handleView(row.leasinginq_id)}>View</button>
                <button style={S.delBtn} onClick={()=>handleDelete(row.leasinginq_id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
     

      <div style={S.pagination}>
          <span style={S.paginInfo}>
            {total > 0 ? `Showing ${(page-1)*10+1}–${Math.min(page*10, total)} of ${total}` : ''}
          </span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button style={S.pgBtn} disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
          <span style={S.paginInfo}>{page}/{totalPages}</span>
          <button style={S.pgBtn} disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
        </div>
        </div>

</div>

      {/* VIEW MODAL */}
     

{viewData && (
          <div style={S.overlay} onClick={()=>setViewData(null)}>
            <div style={{...S.modal,maxWidth:560,background:'rgb(255, 255, 255)',borderRadius:'10px'}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>🚗 View Leasing Inquiry</h2>
                  </div>
                <button style={S.xBtn} onClick={()=>setViewData(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'16px 28px 20px'}}>

                {/* Customer hero */}
                <div style={{display:'flex',alignItems:'center',gap:16,padding:'16px',
                  background:'linear-gradient(135deg,#fffbeb,#fef3c7)',
                  borderRadius:16,marginBottom:20,border:'1.5px solid #fde68a'}}>
                  
                  <div>

                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                      {viewData.name && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Name :</span> {viewData.name}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.email && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Email :</span> {viewData.email}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.contact_no && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Mobile :</span> {viewData.contact_no}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.lease_period && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Lease Period : </span>{viewData.lease_period} Years
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.model_name && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Model Name :</span> {viewData.model_name}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.country && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                        <span style={S.nameTages}>Country :</span>   {viewData.country}
                        </span>
                      )}
                    </div>
                  
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.company_name && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Company Name :</span> {viewData.company_name}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.address && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                          <span style={S.nameTages}>Address :</span> {viewData.address}
                        </span>
                      )}
                    </div>
                    <div style={{display:'flex',gap:8,marginTop:4,flexWrap:'wrap'}}>
                    {viewData.additional_feature && (
                        <span className="badge" style={{background:'#fef3c7',color:'#b45309'}}>
                           <span style={S.nameTages}>Additional Features :</span> {viewData.additional_feature}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Contact info */}
                {[
                 
                 
                ].filter(r=>r.value).map(row=>(
                  <div key={row.label} className="info-row">
                    <div className="info-icon">{row.icon}</div>
                    <div>
                      <div style={{fontSize:10,color:'#f59e0b',fontWeight:700,
                        textTransform:'uppercase',letterSpacing:'0.4px'}}>{row.label}</div>
                      <div style={{fontSize:14,color:'#1a1d2e',fontWeight:500,marginTop:2}}>
                        {row.value}
                      </div>
                    </div>
                  </div>
                ))}

                

                {/* Comments */}
                {viewData.message && (
                  <div style={{marginTop:16}}>
                    <div style={{fontSize:11,color:'#b45309',fontWeight:700,
                      textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:8}}>
                      💬 Comments / Details
                    </div>
                    <div style={{background:'#fffbeb',borderRadius:12,padding:'14px 16px',
                      border:'1.5px solid #fde68a',fontSize:14,color:'#374151',
                      lineHeight:1.7,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
                      {viewData.message}
                    </div>
                  </div>
                )}
              </div>
              
            </div>
          </div>
        )}

    </Layout>
  );
}


/* ─── Styles ─── */
const S = {
    root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  
     /* Header */
  header: { marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

   
    /* Main */
    main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
    topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
    subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
    addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },
  
    /* Filters */
    filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
    searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
      border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
      flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
      fontFamily: 'inherit', color: '#333', background: 'transparent' },
    clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
    filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
      background: '#fff', minWidth: 180 },
  
    /* Card + Table */
    card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden',padding:'20px',marginBottom:'30px' },
    table: { width: '100%', borderCollapse: 'collapse' },
    theadRow: { background: '#fafafa' },
    th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
      textAlign: 'center', borderBottom: '2px solid #f0f0f0',
      textTransform: 'uppercase', letterSpacing: '0.5px' },
    tr: { transition: 'background 0.12s' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
    emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
    noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },
  
    /* Chips */
    serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
    pctChip:   { borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
    nameTages: {color:'rgb(223, 78, 78)',fontWeight:'bold'},
    /* Action buttons */
    viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
      border: '1px solid #b8f0d0', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    delBtn: { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
      padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
      fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
      xBtn:{background:'rgba(236,72,153,0.12)',border:'none',color:'#be185d',borderRadius:'50%',
      width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
      display:'flex',alignItems:'center',justifyContent:'center'},
    /* Pagination */
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
    paginInfo: { fontSize: 12, color: '#999' },
    pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  
    /* Modal */
    overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
    modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
      display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
    modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
    modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
    modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
      padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
    closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
      borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
    cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
      border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
    submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Form */
    section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
      letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
      borderBottom: '1.5px solid #f3f2ff' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
    fg: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: 12, fontWeight: 600, color: '#555' },
    req: { color: '#ff6b6b' },
    input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',marginBottom:'10px',
      boxSizing: 'border-box' },
  };
  